import { css } from "@emotion/react";

import colours from "./colours";
import transitions from './transitions';
import zIndex from './zIndex';
import { fonts } from "./fonts";
import { FLOATING_UI_SCREEN_EDGE_MARGIN_PX } from "./layout";
import borderAndShadow from "./borderAndShadow";

const mixins = {
    bloop: `
        transition: transform ${transitions.transitionFastest};
        &:hover {
            transform: scale(1.1);
        }
    `,
    bloopScale: `
        transform: scale(1.1);
    `,
    placeholderAttributes: (content?: any) => `
        font-family: ${fonts.frutiger};
        font-weight: ${fonts.weights.light};
        color: ${colours.grey[450]};
        opacity: 1; /** Safari / Firefox **/

        ${content};
    `,

    placeholder: (content?: any) => `
        &::placeholder { /** Chrome **/
            ${mixins.placeholderAttributes(content)};

            /** We put @content after the above include, so that the @content can override **/
            ${content};
        }

        /** This css doesn't work with the list below **/
        &::-webkit-input-placeholder, /** Opera/Safari **/
        &::-moz-placeholder, /** Firefox 19+ **/
        &:-moz-placeholder { /** Firefox 18- **/
            ${mixins.placeholderAttributes(content)};

            /** We put @content after the above include, so that the @content can override **/
            ${content};
        }

        /** IE: This css doesn't work with the list above **/
        &:-ms-input-placeholder {
            ${mixins.placeholderAttributes(content)};

            /** We put @content after the above include, so that the @content can override **/
            ${content};
        }

        /** Edge: This css doesn't work with the list above **/
        &::-ms-input-placeholder {
            ${mixins.placeholderAttributes(content)};

            /** We put @content after the above include, so that the @content can override **/
            ${content};
        }
    `,
    input: (backgroundColor?: string) => `
        input,
        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
            background-color: ${backgroundColor};
            -webkit-box-shadow: 0 0 0 30px ${backgroundColor} inset;
        }
    `,
    dangerouslySetInnerHtml: `
        strong {
            font-weight: bold;
        }

        em {
            font-style: italic;
        }

        blockquote {
            margin-left: 40px;
        }

        table {
            width: 100%;
        }

        td {
            border: 1px solid ${colours.silverChalice2};
            vertical-align: middle;
        }

        ul,ol {
            margin-left: 40px;
        }

        ul {
            list-style: disc;
        }

        ol {
            list-style: decimal;
        }
    `,
    modal: {
        defaultOverlayStyle: css`
            display: grid;
            place-items: center;
            background-color: rgba(0, 0, 0, .5);
            z-index: ${zIndex.zIndexHigher};
        `,

        containerMaxDimsWithEdgeMargins: css`
            max-height: calc(100vh - ${FLOATING_UI_SCREEN_EDGE_MARGIN_PX}px * 2);
            max-width: calc(100% - ${FLOATING_UI_SCREEN_EDGE_MARGIN_PX}px * 2);
        `,

        columnContainer: css`
            display: flex;
            flex-direction: column;
            overflow: hidden;
        `,

        roundedContainer: css`
            border-radius: ${borderAndShadow.largeRadius};
            overflow: hidden;
        `,

        whiteBackground: css`
            background-color: white;
        `,

        get niceContainerBase() {
            return css`
                ${this.containerMaxDimsWithEdgeMargins};
                ${this.columnContainer};
                ${this.roundedContainer};
                ${this.whiteBackground};
            `;
        },

        // To be applied to the overlay, which contains the container.
        get defaultStyle() {
            return css`
                ${this.defaultOverlayStyle};

                .modal-container {
                    ${this.niceContainerBase};
                }
            `;
        },
    }
};

const v = {
    ...mixins,
};
export default v;
